import { AppContext } from "@/services/AppContext/appContext";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/shadcn/components/ui/select";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";

type ChatNoMessagesProps = {
  // TODO: add props here
};

const ChatNoMessages: React.FC<ChatNoMessagesProps> = (props) => {
  const { t } = useTranslation();
  const { setSelectedAgentModel, agentsModels, selectedAgentModel } =
    useContext(AppContext);

  if (!agentsModels || agentsModels.length === 0) {
    return (
      <div className="m-auto flex h-full w-full items-center justify-center text-lg font-bold text-white opacity-80 select-none">
        Loading agents...
      </div>
    );
  }

  return (
    <div className="m-auto flex h-full w-full items-center justify-center">
      <div className="m-auto flex flex-col items-center justify-center gap-4">
        <div className="m-auto flex h-full w-full items-center justify-center text-lg font-bold text-white opacity-80 select-none">
          {t("Hello! How can I help you today?")}
        </div>
        {!selectedAgentModel && (
          <Select
            onValueChange={(value) => {
              const selectedAgentModel = agentsModels.find(
                (agentModel) => agentModel.id.toString() === value
              );
              if (selectedAgentModel) {
                setSelectedAgentModel(selectedAgentModel);
              }
            }}
          >
            <SelectTrigger className="w-[180px]">
              <SelectValue placeholder="Select an agent" />
            </SelectTrigger>
            <SelectContent>
              <SelectGroup>
                <SelectLabel>Agents</SelectLabel>
                {agentsModels.map((agentModel) => (
                  <SelectItem
                    key={agentModel.id}
                    value={agentModel.id.toString()}
                  >
                    {agentModel.name}
                  </SelectItem>
                ))}
              </SelectGroup>
            </SelectContent>
          </Select>
        )}
      </div>
    </div>
  );
};

export default ChatNoMessages;
